import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dropdown']

  show() {
    this.dropdownTarget.classList.remove('hidden')
  }

  // Delay gives iOS Safari time to fire the tap before the dropdown disappears
  hide() {
    this._hideTimer = setTimeout(() => {
      this.dropdownTarget.classList.add('hidden')
    }, 300)
  }

  cancelHide() {
    clearTimeout(this._hideTimer)
  }
}
